module.exports = __webpack_public_path__ + "img/mian-bg.72bcdea4.png";